{
  "version": 1,
  "asset_id": "5538dcef-e0c2-49af-af34-699cefc1a1b9",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/5538dcef-e0c2-49af-af34-699cefc1a1b9/clip-img_2161-poster-sm.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/5538dcef-e0c2-49af-af34-699cefc1a1b9/clip-img_2161-poster-sm.webp",
  "original_filename": "clip-img_2161-poster-sm.webp",
  "size": 6842,
  "content_type": "image/webp",
  "created_at": "2026-08-01T21:10:33Z"
}
